import N8nTooltip from './Tooltip.vue';

export default N8nTooltip;
